import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
const items = ['Tutti i 10 volumi completi, pronti da stampare', 'Teoria, pratica e verifiche allineate in ogni unità', 'Percorso pronto dalla classe 1ª primaria alla 3ª media', 'Schede pronte all\u2019uso, senza bisogno di formazione musicale', 'Materiali allineati alle Nuove Indicazioni Nazionali', 'Nessun abbonamento: accesso immediato e permanente'];
export function InstantAccess() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-24" data-id="element-122" data-mp="1hhgihj1efzvr">
      <div className="mx-auto max-w-3xl" data-id="element-123" data-mp="1mbko9yyxi1v9">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.22em] text-orange sm:text-xs" data-id="element-124" data-mp="17l3pkndohq22">
          Accesso immediato
        </p>
        <h2 className="mt-4 flex items-center justify-center gap-3 text-center text-[26px] font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-125" data-mp="1ckq02p24gs76">
          <ZapIcon className="h-6 w-6 flex-none text-orange sm:h-7 sm:w-7" aria-hidden="true" data-id="element-126" data-mp="13jibwztbl7qt" />
          Cosa Ottieni Subito?
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-127" data-mp="1w3jgoac8eo80">
          {items.map(item => <li key={item} className="flex items-start gap-4 rounded-2xl border border-navy/10 bg-white px-6 py-5" data-id="element-128" data-mp="1s3ivm6umnerz">
              <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-mint" data-id="element-129" data-mp="260o6ql9773u3">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-130" data-mp="1de360u6u1fdv" />
              </span>
              <span className="text-[15px] leading-relaxed text-ink" data-id="element-131" data-mp="18f0dg981h1ms">{item}</span>
            </li>)}
        </ul>

        <p className="mt-8 text-center text-lg font-bold text-orange" data-id="element-132" data-mp="1n4ejb7cep0xf">
          Non rimarrai mai più senza materiale.
        </p>
      </div>
    </section>;
}